import { initializeApp, getApps, getApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Public web config for the shared `keto-diet-guide` Firebase project
// ("MyKeto Web" app registration). Same project as the mobile app and the
// legacy RTDB world — public by design.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyBCyur1HFf7SQ0Ke0rtsb1QxayeLL3vzZY',
  authDomain: 'keto-diet-guide.firebaseapp.com',
  projectId: 'keto-diet-guide',
  storageBucket: 'keto-diet-guide.appspot.com',
  messagingSenderId: '576543677526',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:576543677526:web:186b3f330ce04875ab2ff7',
  measurementId: 'G-TGT80CYBM6',
}

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

export const auth = getAuth(app)

// Offline persistence (IndexedDB) — flaky connections keep working.
// ignoreUndefinedProperties matches the mobile writers' strip-undefined behavior:
// analysis payloads have optional nutrients, and Firestore rejects undefined otherwise.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
})

export const functions = getFunctions(app)
export const storage = getStorage(app)

// Keep the session across reloads/tabs.
void setPersistence(auth, browserLocalPersistence).catch(() => {
  /* falls back to in-memory if storage is unavailable */
})

export const googleProvider = new GoogleAuthProvider()

export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')
